export type TimelineSegment =
  | { type: 'rise'; divisions: number }      // /4 means rise for 4 divisions
  | { type: 'fall'; divisions: number }      // \4 means fall for 4 divisions
  | { type: 'hold'; value: number; divisions: number }  // ' means 1, . means 0, '4 means 1 for 4 divisions

export function parseTimelineString(timelineStr: string): TimelineSegment[] {
  const segments: TimelineSegment[] = []
  let i = 0

  while (i < timelineStr.length) {
    const char = timelineStr[i]

    if (char === '/') {
      // Rise: /4 means rise for 4 divisions
      i++
      let numStr = ''
      while (i < timelineStr.length && /\d/.test(timelineStr[i])) {
        numStr += timelineStr[i]
        i++
      }
      const divisions = numStr ? parseInt(numStr, 10) : 1
      if (divisions <= 0) {
        throw new Error(`Invalid rise divisions: ${numStr}`)
      }
      segments.push({ type: 'rise', divisions })
    }
    else if (char === '\\') {
      // Fall: \4 means fall for 4 divisions
      i++
      let numStr = ''
      while (i < timelineStr.length && /\d/.test(timelineStr[i])) {
        numStr += timelineStr[i]
        i++
      }
      const divisions = numStr ? parseInt(numStr, 10) : 1
      if (divisions <= 0) {
        throw new Error(`Invalid fall divisions: ${numStr}`)
      }
      segments.push({ type: 'fall', divisions })
    }
    else if (char === "'") {
      // Hold at 1: ' means 1 for 1 division, '4 means 1 for 4 divisions
      i++
      let numStr = ''
      while (i < timelineStr.length && /\d/.test(timelineStr[i])) {
        numStr += timelineStr[i]
        i++
      }
      const divisions = numStr ? parseInt(numStr, 10) : 1
      if (divisions <= 0) {
        throw new Error(`Invalid hold divisions: ${numStr}`)
      }
      segments.push({ type: 'hold', value: 1, divisions })
    }
    else if (char === '.') {
      // Hold at 0: . means 0 for 1 division, .4 means 0 for 4 divisions
      i++
      let numStr = ''
      while (i < timelineStr.length && /\d/.test(timelineStr[i])) {
        numStr += timelineStr[i]
        i++
      }
      const divisions = numStr ? parseInt(numStr, 10) : 1
      if (divisions <= 0) {
        throw new Error(`Invalid hold divisions: ${numStr}`)
      }
      segments.push({ type: 'hold', value: 0, divisions })
    }
    else if (/\s/.test(char)) {
      // Skip whitespace
      i++
    }
    else {
      throw new Error(`Invalid timeline character: ${char}`)
    }
  }

  return segments
}

